import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/sales/list", {
    type: "sales",
    ...params,
  });
};

export const changeSales = async (params) => {
  return await fetchFinance("/action", {
    action: "updateSales",
    ...params,
  });
};

export const createSales = async (params) => {
  return await fetchFinance("/action", {
    action: "updateSales",
    ...params,
  });
};

export const updateCommission = async (params) => {
  return await fetchFinance("/action", {
    action: "updateSalesCommission",
    ...params,
  });
};
